// ======================================================================
// File Name       : ParticipantDetailStatus
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================


import React from 'react';
import { Form, FormControl, Col, InputGroup, Button, Table } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { onChangeWrapper } from '../../../utils/FormUtils';
import { VALIDATE_TYPE } from '../../../constants/index';
import FormControlValidate from '../../FormControlValidate';
import RenderField from '../../../utils/ReduxFormUtils';
import PaginationCustom from '../../Pagination';
import ReduxFormPaging from '../../ReduxFormPaging';
import TableHead from '../../../components/TableHead';
import LiveProgressDetailChart from '../../LiveProgressDetailChart';
import { getLiveStartTime, percentLiveProgressRatio } from '../../../utils/UsageSettingLiveUtils';

class ParticipantDetailStatus extends React.Component {
  render() {
    const {
      liveList,
      liveRecordNum,
      getStartEndData,
    } = this.props;
    const thead = [
      { title: 'ライブ名', sortBy: null },
      { title: 'ライブ開催者名', sortBy: null },
      { title: 'ライブ実施日時', sortBy: null },
      { title: '参加状況', sortBy: null },
      { title: '滞在履歴', sortBy: null, width: 250 },
    ];
    return (
      <div>
        <Col sm={12}>
          <Table striped hover>
            <thead>
              <TableHead data={thead} />
            </thead>
            <tbody>
            {
            liveList && liveList.length > 0 && liveList.map((item, index) => {
              const {
                participantUserSecernId,
                liveStatus,
                liveProgressRatio,
                arrayDataSetsForChart,
                liveName,
                liveSecernId,
                userName,
                liveStartFrom,
                liveStartTo,
              } = item;
              return (
                <tr key={index}>
                  <td>
                    {liveName}
                  </td>
                  <td>
                    {userName}
                  </td>
                  <td style={{ wordBreak: 'break-word' }}>
                    {getLiveStartTime(liveStartFrom, liveStartTo)}
                  </td>
                  <td>
                    {percentLiveProgressRatio(liveProgressRatio)}
                  </td>
                  <td>
                    <LiveProgressDetailChart
                      arrayDataSetsForChart={arrayDataSetsForChart}
                      liveSecernId={liveSecernId}
                      index={index}
                    />
                  </td>
                </tr>
              );
            })
            }
            </tbody>
          </Table>
        </Col>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={liveRecordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default ParticipantDetailStatus;
